@if (show) {
<div
  #toastElement
  class="custom-toast"
  [ngClass]="type"
  (touchstart)="onTouchStart($event)"
  (touchmove)="onTouchMove($event)"
  (touchend)="onTouchEnd($event)"
>
  <div class="icon-container">
    <div class="icon-wrapper" [ngClass]="type">
      <ion-icon [name]="getIconName()" class="icon" />
    </div>
  </div>
  <div class="message">
    {{ message }}
  </div>
</div>
}
